import InputHandler from "./InputHandler";
import React from "react";
import {ButtonActionStyled, LanguageCardStyled} from "../../../styled/Resume";
import {FaPlus} from "react-icons/fa6";
import {useTheme} from "../../UI/Theme/ThemeContext";


const LanguageCard = (props)=> {
    const {
        languages,
        handleLangChange,
        languageStore,
        langLevelsArray,
        handleDeleteLang,
        handleAddLang,


    } = props;
    const {themeName} = useTheme();

    return (
        <LanguageCardStyled theme={themeName}>
            <div className="items">
                {languages && languages.map((language, index) => (
                        <InputHandler
                            key={index}
                            type="language"
                            languageValue={language.language} 
                            languageName="language"
                            languageLabel="Language" 
                            languageList={languageStore} 
                            languageOnChange={(event) => handleLangChange(event, index)}
                            levelValue={language.level} 
                            levelName="level"
                            levelLabel="Level" 
                            levelList={langLevelsArray} 
                            levelOnChange={(event) => handleLangChange(event, index)}
                            handleDeleteLang={handleDeleteLang}
                        />
                ))}
            </div>

            <ButtonActionStyled skill>
                <span className="add" onClick={handleAddLang}> <FaPlus/> </span>
            </ButtonActionStyled>


        </LanguageCardStyled>


    );
}

export default LanguageCard;